import { TvvBesteldeRoute, useMarkEtasPubliek } from "@/entities/tvv";
import { Button, ConfirmDialog, Dot } from "@/shared/components";
import { useState } from "react";

type CommunicateEtasProps = {
    route: TvvBesteldeRoute;
};

function CommunicateEtas({ route }: CommunicateEtasProps) {
    const [isOpen, setIsOpen] = useState(false);
    const mutation = useMarkEtasPubliek();
    const { id, dossierId, etasPubliek } = route;

    const handleConfirm = () => {
        mutation.mutate({ dossierId: String(dossierId), tvvId: id, etasPubliek: true }, { onSuccess: () => setIsOpen(false) });
    };

    return (
        <div className="flex items-center gap-4">
            {!etasPubliek && (
                <Button variant="secondary" size="s" icon="megaphone" iconSize="xs" onClick={() => setIsOpen(true)}>
                    Toon ETAs bussen in Wissel
                </Button>
            )}
            <p
                className={`text-s flex items-center gap-1 ${etasPubliek ? "text-content-default" : "text-content-subtle"}`}
                data-testid="etas-zichtbaar"
            >
                <Dot variant={etasPubliek ? "succes" : "neutral"} />
                Bus ETAs {!etasPubliek && "niet"} zichtbaar in Wissel
            </p>
            <ConfirmDialog
                title="Toon bus ETAs in Wissel"
                isOpen={isOpen}
                isPending={mutation.isPending}
                error={mutation.error}
                onCancel={() => setIsOpen(false)}
                onConfirm={handleConfirm}
            >
                Weet je zeker dat je de ETAs van de bussen wil tonen in Wissel? Dit kan niet ongedaan gemaakt worden.
            </ConfirmDialog>
        </div>
    );
}

export default CommunicateEtas;
